<template>
  <div class="lead-flow-action-fields">
    <label v-if="showReason" class="lead-flow-action-fields__field">
      <span>
        Reason
        <em v-if="reasonRequired">*</em>
      </span>
      <app-select
        design="new"
        :value="form.reason"
        :options="reasonOptions"
        :clearable="!reasonRequired"
        :error="Boolean(errors.reason)"
        placeholder="Select reason"
        @input="change('reason', $event)"
      />
      <small v-if="errors.reason">{{ errors.reason }}</small>
    </label>

    <label v-if="showCommunicationMethod" class="lead-flow-action-fields__field">
      <span>Communication method <em>*</em></span>
      <app-select
        design="new"
        :value="form.communicationMethod"
        :options="communicationMethods"
        :clearable="false"
        :error="Boolean(errors.communicationMethod)"
        placeholder="Select method"
        @input="change('communicationMethod', $event)"
      />
      <small v-if="errors.communicationMethod">{{ errors.communicationMethod }}</small>
    </label>

    <label v-if="showNote" class="lead-flow-action-fields__field lead-flow-action-fields__field--wide">
      <span>
        {{ action.note_label || 'Note' }}
        <em v-if="noteRequired">*</em>
        <i v-else>optional</i>
      </span>
      <AppTextarea
        design="new"
        :value="form.note"
        rows="3"
        :error="Boolean(errors.note)"
        :placeholder="action.note_placeholder || 'Add a short note'"
        @input="change('note', $event || '')"
      />
      <small v-if="errors.note">{{ errors.note }}</small>
    </label>
  </div>
</template>

<script>
export default {
  name: 'LeadFlowActionFields',
  props: {
    action: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    communicationMethods: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    fields() {
      return this.action.fields || {}
    },
    reasonOptions() {
      const reason = this.fields.reason || {}
      return Array.isArray(reason.options) ? reason.options : []
    },
    reasonRequired() {
      return Boolean(this.fields.reason && this.fields.reason.required)
    },
    noteRequired() {
      return Boolean((this.fields.note && this.fields.note.required) || this.action.note_required)
    },
    showReason() {
      return this.reasonRequired || this.reasonOptions.length > 0
    },
    showCommunicationMethod() {
      return Boolean(this.fields.communication_method && this.fields.communication_method.required)
    },
    showNote() {
      return Boolean(this.fields.note || this.action.note_required || this.action.note_label)
    }
  },
  methods: {
    change(field, value) {
      this.$emit('change', field, value)
    }
  }
}
</script>

<style scoped>
.lead-flow-action-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.lead-flow-action-fields__field {
  display: grid;
  min-width: 0;
  gap: 6px;
  margin: 0;
}

.lead-flow-action-fields__field--wide {
  grid-column: 1 / -1;
}

.lead-flow-action-fields__field > span {
  color: #526264;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.lead-flow-action-fields__field em {
  color: #ba554d;
  font-style: normal;
}

.lead-flow-action-fields__field i {
  color: #9aa4a2;
  font-style: normal;
  font-weight: 500;
  text-transform: none;
}

.lead-flow-action-fields textarea {
  width: 100%;
  min-height: 74px;
  resize: vertical;
  padding: 10px 11px;
  border: 1px solid #d9dfd8;
  border-radius: 6px;
  color: #26393b;
  font: inherit;
  font-size: 12px;
  line-height: 17px;
}

.lead-flow-action-fields__control--error {
  border-color: #c86b63 !important;
}

.lead-flow-action-fields__field > small {
  color: #b85049;
  font-size: 10px;
}

@media (max-width: 700px) {
  .lead-flow-action-fields {
    grid-template-columns: 1fr;
  }

  .lead-flow-action-fields__field--wide {
    grid-column: auto;
  }
}
</style>
